import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { logmapUrl, apiKeyUrl } from './common.js'
// Vue.use(Element, { size: 'small', zIndex: 3000 })


import L from "leaflet";

import "leaflet/dist/leaflet.css";

import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen';

// import '@/utils/Leaflet.ShowHideLayerGroup.js';

import * as echarts from 'echarts'

import AutoReport from 'AutoReport';

import "leaflet-canvas-marker";
Vue.use(ElementUI);
Vue.use(L);

import waterfall from 'vue-waterfall2';
Vue.use(waterfall);

Vue.prototype.$bus = new Vue();
Vue.prototype.$echarts = echarts;

Vue.prototype.$AutoReport = AutoReport.AutoReport;
Vue.config.productionTip = false

initReport()

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
console.log(logmapUrl, apiKeyUrl)
function initReport() {
    const reporter = new AutoReport.AutoReport(
        "deepbone",
        logmapUrl,
        apiKeyUrl,
        "guest"
    );
    Vue.prototype.$reporter = reporter;
    reporter.init(initOkEvent);
}

function initOkEvent() {
    console.log('haha')
}
